import { Link } from 'react-router-dom'
import { EstadoVazio } from '../../components/Estados'
import { TEXTOS } from '../../lib/glossario'

/**
 * A tela existe, mas não é para este usuário.
 *
 * É diferente de "endereço não existe", e a diferença é a que interessa a quem está lendo: a
 * pessoa da contratada que digitar `/fiscalizacao` precisa entender que a tela é real e que o
 * acesso é que não é dela — senão insiste, abre chamado, e alguém perde meia hora explicando.
 *
 * O motivo é dito sem eufemismo. A fiscalização mede a execução do contrato e produz glosa sobre a
 * fatura; quem é medido não a enxerga. Não é desconfiança da pessoa, é separação de papéis, e
 * escrever isso na tela evita que pareça a primeira coisa.
 *
 * @returns a tela de acesso não permitido
 */
export function SemAcesso() {
  return (
    <EstadoVazio
      titulo={TEXTOS.semAcesso.titulo}
      ajuda={TEXTOS.semAcesso.ajuda}
      acao={
        <div className="flex flex-wrap justify-center gap-2">
          <Link
            to="/painel"
            className="rounded-lg bg-niteroi-700 px-3.5 py-2 text-sm font-medium text-white hover:bg-niteroi-800"
          >
            Ir para o painel
          </Link>
          <Link
            to="/gmuds"
            className="rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-sm font-medium text-slate-800 hover:bg-slate-50"
          >
            Ver as solicitações
          </Link>
        </div>
      }
    />
  )
}
